// const dataScienceQ = {
//     topic: 'Data Science',
//     questions: [
//         {
//             label: 'Data Manipulation with Pandas',
//             question:
//                 "Given the following dataset in CSV format\nName, Age, Salary\nAlice, 30, 70000\nBob, 25, 50000\nCharlie, 35, 120000\nDavid, 40, 150000\nEva, 29, 62000\nWrite a Python script to:\n1. Load the dataset into a Pandas DataFrame.\n2. Calculate the mean and median age.\n3. Filter the DataFrame to include only people with a salary above 60,000.",
//             answer:
//                 "import pandas as pd\n\n# Load the dataset\ndata = pd.read_csv('path_to_csv_file.csv')\n\n# Calculate mean and median age\nmean_age = data['Age'].mean()\nmedian_age = data['Age'].median()\n\n# Filter DataFrame for salary above 60,000\nhigh_salary = data[data['Salary'] > 60000]\n\nprint(\"Mean Age:\", mean_age)\nprint(\"Median Age:\", median_age)\nprint(\"High Salary DataFrame:\\n\", high_salary)"
//         }
//     ]
// };

const powerBiAndDataScienceQ = {
    topic: 'Power Bi & Data Science',
    questions: [
        {
            questionId: 1,
            label: 'Data Manipulation with Pandas',
            question:
                "Given the following dataset in CSV format\nName, Age, Salary\nAlice, 30, 70000\nBob, 25, 50000\nCharlie, 35, 120000\nDavid, 40, 150000\nEva, 29, 62000\nWrite a Python script to:\n1. Load the dataset into a Pandas DataFrame.\n2. Calculate the mean and median age.\n3. Filter the DataFrame to include only people with a salary above 60,000.",
            correctAnswer:
                `import pandas as pd
                # Load the dataset
                data = pd.read_csv('path_to_csv_file.csv')
                # Calculate mean and median age
                mean_age = data['Age'].mean()
                median_age = data['Age'].median()
                # Filter DataFrame for salary above 60,000
                high_salary = data[data['Salary'] > 60000]
                print(\"Mean Age:\", mean_age)
                print(\"Median Age:\", median_age)
                print(\"High Salary DataFrame:", high_salary)`
        },
        {
            questionId: 2,
            label: 'Statistical Analysis',
            question:
                "You are given the following list of numbers representing the ages of a group of people:\n`ages = [25, 30, 35, 40, 29, 30, 31, 28, 34, 36]`\n\nWrite a Python function to:\n1. Calculate the standard deviation of the ages.\n2. Calculate the 95% confidence interval for the mean age.",
            correctAnswer: `
                import numpy as np
                import scipy.stats as stats
                 
                # Given list of ages
                ages = [25, 30, 35, 40, 29, 30, 31, 28, 34, 36]
                
                # Calculate standard deviation\nstd_dev = np.std(ages, ddof=1)
                
                # Calculate 95% confidence interval for the mean
                mean_age = np.mean(ages)
                confidence_interval = stats.t.interval(0.95, len(ages)-1, loc=mean_age, scale=stats.sem(ages))
                print("Standard Deviation:", std_dev)
                print("95% Confidence Interval:", confidence_interval)`
        },
        {
            questionId: 3,
            label: 'Machine Learning with Scikit-Learn',
            question:
                "Using the Iris dataset, write a Python script to:\n1. Load the Iris dataset from scikit-learn.\n2. Split the dataset into training and testing sets (80% train, 20% test).\n3. Train a k-Nearest Neighbors classifier with the training set.\n4. Evaluate the model's accuracy on the testing set.",
            correctAnswer: `
                from sklearn.datasets import load_iris
                from sklearn.model_selection import train_test_split
                from sklearn.neighbors import KNeighborsClassifier
                from sklearn.metrics import accuracy_score
                
                # Load the Iris dataset
                iris = load_iris()
                X, y = iris.data, iris.target
                # Split into training and testing sets
                X_train, X_test, y_train, y_test = train_test_split(X, y, test_size=0.2, random_state=42)
                # Train k-Nearest Neighbors classifier
                knn = KNeighborsClassifier(n_neighbors=3)
                knn.fit(X_train, y_train)
                
                # Predict on the testing set
                y_pred = knn.predict(X_test)
                
                # Evaluate accuracy\naccuracy = accuracy_score(y_test, y_pred)
                print("Accuracy:", accuracy)`
        },
        {
            questionId: 4,
            label: 'Data Visualization with Matplotlib',
            question:
                "Write a Python script to create a bar plot using Matplotlib to show the average salary for each age group from the following dataset:\n```\nAge, Salary\n25, 50000\n30, 70000\n35, 120000\n40, 150000\n29, 62000\n```",
            correctAnswer: `
                import pandas as pd
                import matplotlib.pyplot as plt
                
                # Given data\ndata = {
                    'Age': [25, 30, 35, 40, 29],
                    'Salary': [50000, 70000, 120000, 150000, 62000]
                }
                df = pd.DataFrame(data)
                
                # Create a bar plot
                plt.figure(figsize=(8, 5))
                plt.bar(df['Age'], df['Salary'], color='skyblue')
                plt.xlabel('Age')
                plt.ylabel('Salary')
                plt.title('Average Salary by Age')
                plt.show()`
        },
        {
            questionId: 5,
            label: 'Basic Statistics with NumPy',
            question:
                `Given a list of numbers and output a list sorted based on frequency of these numbers. If the frequency is same then higher number will get priority
                Input = [7, 2, 6, 6, 5, 3, 5, 5, 3, 3]
                Output = [5, 5, 5, 3, 3, 3, 6, 6, 7, 2]`,
            correctAnswer:
                `from collections import Counter
                ndef custom_sort(nums):
                
                # Step 1: Count the frequency of each number
                counts = Counter(nums)
                        
                # Step 2: Sort based on frequency, with higher frequencies first
                # For numbers with the same frequency, sort them in descending order
                sorted_nums = sorted(nums, key = lambda x: (-counts[x], x))
                return sorted_nums
                # Input list 
                input_list =[7, 2, 6, 6, 5, 3, 5, 5, 3, 3]
                
                # Output sorted list\noutput_list = custom_sort(input_list)
                print(output_list)
                
                # Code using NumPy:
                import numpy as np
                
                def custom_sort(nums):
                
                # Convert the list to a NumPy array
                nums_array = np.array(nums)
                
                # Get unique numbers and their frequencies
                unique_nums, counts = np.unique(nums_array, return_counts = True)
                
                # Sort based on frequency, with higher frequencies first
                # For numbers with the same frequency, sort them in descending order
                sorted_indices = np.lexsort((-counts, unique_nums))
                sorted_nums = unique_nums[sorted_indices]
                
                # Repeat each number according to its frequency
                sorted_nums = np.repeat(sorted_nums, counts[sorted_indices])
                
                return sorted_nums.tolist()
                
                # Input list
                input_list =[7, 2, 6, 6, 5, 3, 5, 5, 3, 3]
                
                # Output sorted list
                output_list = custom_sort(input_list) 
                print(output_list)`
        }
    ]
};

export default powerBiAndDataScienceQ;
